import React from 'react';
import ReactDOM from 'react-dom';
import InstantEditValidateBox from './InstantEditValidateBox.jsx';
import Validate from '../core/Validate';
import Translate from '../core/Translate';

class ParserSelectorTable extends React.Component {
	constructor(props) {
        super(props);
        this.values = [['','']];
        if(!!props.initialClauses){
            var itemArray = [];
            props.initialClauses.forEach( item => {
                itemArray.push([item['key'],item['value']]);
            })
            this.values = itemArray;
        }
		this.state = {
		    values: this.values
		};
	}
	
	handleChange(row, col, val) {
	    this.values[row][col] = val;
	    this.commitValue();
	}
	
	removeRow(idx) {
        if(this.values.length > 1) {
            this.values.splice(idx, 1);
            this.commitValue();
        }
	}
	
	addRow(idx) {
	    this.values.push(['', '']);
	    this.commitValue();
	}
	
	commitValue() {
	    this.setState({
			value: this.values
		});
		
		this.props.onChange.call(null, this.values);
	}

	render() {
	    var trs = this.values.map((pair, idx) => {
            if(idx === this.values.length - 1) {
                if(this.values.length === 1) {
                    var elButtons = (<span>
                        <button className="btn-unobt" disabled>
                            <i className="fa fa-times"></i>
                        </button>
                        <button className="btn-unobt" onClick={this.addRow.bind(this, idx)}>
                            <i className="fa fa-times" style={{'transform': 'rotate(45deg)'}}></i>
                        </button>
                    </span>)
                }
                else {
                    var elButtons = (<span>
                        <button className="btn-unobt" onClick={this.removeRow.bind(this, idx)}>
                            <i className="fa fa-times"></i>
                        </button>
                        <button className="btn-unobt" onClick={this.addRow.bind(this, idx)}>
                            <i className="fa fa-times" style={{'transform': 'rotate(45deg)'}}></i>
                        </button>
                    </span>)
                }
                    
            }
            else {
                var elButtons = (
    	            <button className="btn-unobt" onClick={this.removeRow.bind(this, idx)}>
                        <i className="fa fa-times"></i>
                    </button>
                )
            }

     	    return (
                <tr key={'pst-tr-' + idx}>
                <td style={{'width': '50%' ,'wordBreak': 'break-all'}}>
                    <InstantEditValidateBox key={'pst-expr-' + idx} model={pair[0]} onChange={this.handleChange.bind(this, idx, 0)} validate={Validate.required} invalidMessage={Translate.get('$S_msg_InvalidRequired', {
					    'p0': Translate.get('$S_str_Condition')
				    })}></InstantEditValidateBox>
                </td>
                <td style={{'width': '50%' ,'wordBreak': 'break-all'}}>
                    <InstantEditValidateBox key={'pst-ret-' + idx} model={pair[1]} onChange={this.handleChange.bind(this, idx, 1)} validate={Validate.required} invalidMessage={Translate.get('$S_msg_InvalidRequired', {
					    'p0': Translate.get('$S_str_ReturnValue')
				    })}></InstantEditValidateBox>
                </td>
                <td style={{'width': '50px', 'minWidth': '50px', 'textAlign':'center'}}>
                    {elButtons}
                </td>
            </tr>)
	    });
	    
	    return (
          
                <table className="table-property" style={{'margin': '0', 'borderStyle': 'hidden'}} width="100%">
                    <thead>
                        <tr style={{'backgroundColor': 'rgb(243,243,243)'}}>
                            <th style={{'width': '50%', 'borderRadius': '0'}}>{Translate.get('$S_str_Condition')}</th>
                            <th style={{'width': '50%', 'borderRadius': '0'}}>{Translate.get('$S_str_ReturnValue')}</th>
                            <th style={{'width': '70px', 'borderRadius': '0'}}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>{trs}</tbody>
                </table>
           );
	}

//     componentWillReceiveProps(nextProps) {
//       //  console.log('componentWillReceiveProps: ', nextProps);
//         this.values = [['','']];
//         if(!!nextProps.initialClauses){
//             this.values = nextProps.initialClauses;
//         }
//         this.state = {
//             values: this.values
//         };
//     }

//     shouldComponentUpdate(nextProps, nextState){
//         // return a boolean value
//         return true;
//     }
}

export default ParserSelectorTable;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/ParserSelectorTable.jsx